import { Link, useLocation } from "@tanstack/react-router";
import type { ReactElement } from "react";
import { HomeIcon } from "../icons/home";
import { EnvelopeIcon } from "../icons/envelope";
import { EnvelopeDarkIcon } from "../icons/envelopeDark";
import { CalendarIcon } from "../icons/calendar";
import { CalendarDarkIcon } from "../icons/calendarDark";
import ProfileIcon from "../icons/profileIcon";
import ProfileIconDark from "../icons/profileIconDark";
import { HeartDarkIcon } from "../icons/heartFull";
import { HeartIcon } from "../icons/heart";

const EVENT_COUNTER_FEATURE_FLAG = false;

export const MenuBottomBar = (): ReactElement => {
	const { pathname } = useLocation();

	return (
		<nav className="flex justify-around w-full">
			<Link className="xxs:p-5" to="/">
				<HomeIcon fill={pathname === "/" ? "#212B36" : "white"} />
			</Link>
			<Link className="xxs:p-5" to="/upcoming-events">
				{pathname === "/upcoming-events" ? (
					<CalendarDarkIcon />
				) : (
					<div className="relative">
						<CalendarIcon />
						{EVENT_COUNTER_FEATURE_FLAG && (
							<div className="absolute z-10 top-[-10px] right-[-10px] bg-notification text-white text-xs font-bold w-5 h-5 flex items-center justify-center rounded-full">
								30
							</div>
						)}
					</div>
				)}
			</Link>
			<Link className="xxs:p-5" to="/my-academy">
				{pathname === "/my-academy" ? <HeartDarkIcon /> : <HeartIcon />}
			</Link>
			<Link className="xxs:p-5" to="/contact">
				{pathname === "/contact" ? <EnvelopeDarkIcon /> : <EnvelopeIcon />}
			</Link>
			<Link className="xxs:p-5" to="/user-profil">
				{pathname === "/user-profil" ? <ProfileIconDark /> : <ProfileIcon />}
			</Link>
		</nav>
	);
};
